export default {
  getServiceArea(state) {
    return state.serviceArea;
  },

  getAreaPoints(state) {
    return state.areaPoints;
  }
};
